(() => {
  const body = document.body;

  const setScrollState = () => {
    body.classList.toggle('mbs-scrolled', window.scrollY > 24);
  };

  requestAnimationFrame(() => body.classList.add('mbs-ready'));
  setScrollState();
  window.addEventListener('scroll', setScrollState, { passive: true });

  document.querySelectorAll('[data-mbs-size-advisor]').forEach((advisor) => {
    if (advisor.dataset.ready === 'true') return;
    advisor.dataset.ready = 'true';

    const trigger = advisor.querySelector('.mbs-size-advisor__trigger');
    const panel = advisor.querySelector('.mbs-size-advisor__panel');
    const height = advisor.querySelector('[data-mbs-height]');
    const weight = advisor.querySelector('[data-mbs-weight]');
    const submit = advisor.querySelector('.mbs-size-advisor__submit');
    const result = advisor.querySelector('.mbs-size-advisor__result');
    const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
    const weightIndex = { w1: 0, w2: 1, w3: 2, w4: 3, w5: 4, w6: 5, w7: 6, w8: 7, w9: 8 };

    trigger?.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });

    submit?.addEventListener('click', () => {
      let index = weightIndex[weight.value];
      if (!height.value || index === undefined) {
        result.textContent = 'Kies eerst je lengte en gewicht.';
        return;
      }

      if (height.value === 'shorter' && index >= 2) index -= 1;
      if (height.value === 'taller' && index <= 4) index += 1;
      const size = sizes[Math.max(0, Math.min(sizes.length - 1, index))];
      result.innerHTML = `<strong>Jouw startadvies: maat ${size}</strong><br>Twijfel je tussen twee maten? Kies dan de grotere maat.`;
    });
  });
})();
